<template>
  <div class="shop-detail-page">
    <!-- ========== 顶部：门店详情区 (1.5个屏幕高度，优先滚动) ========== -->
    <div class="shop-info-wrap">
      <div class="shop-info">
        <!-- 这里放你的门店详情内容：门店名称、地址、图片、介绍等 -->
        <h2>XX门店详情</h2>
        <p>门店地址：长沙市XX区XX路XX号</p>
        <p>营业时间：09:00-22:00</p>
        <p>门店评分：4.9分</p>
        <p
          >门店介绍：这里是门店的详细介绍内容，高度占1.5个屏幕，向下滑动先滚动这部分...</p
        >
      </div>
    </div>

    <!-- ========== Tab栏：吸顶核心区 【关键1：占位容器，解决吸顶页面跳动】 ========== -->
    <div
      class="tab-placeholder"
      :style="{ height: isTabFixed ? '50px' : '0' }"
    ></div>
    <!-- Tab栏主体：动态绑定吸顶样式 -->
    <div class="tab-nav" ref="tabRef" :class="{ 'tab-fixed': isTabFixed }">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'hot' }"
        @click="changeTab('hot')"
      >
        最热
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'new' }"
        @click="changeTab('new')"
      >
        最新
      </div>
    </div>

    <!-- ========== Tab内容区：UGC列表 【关键2：v-show控制显隐，保留DOM和滚动位置】 ========== -->
    <div class="tab-content">
      <!-- 最热UGC列表 -->
      <div class="content-item hot-list" v-show="activeTab === 'hot'">
        <div v-if="loadingHot" class="loading">加载中...</div>
        <div
          v-else
          class="ugc-item"
          v-for="(item, index) in hotList"
          :key="index"
        >
          【最热】UGC内容{{ index + 1 }}：{{ item.content }}
        </div>
        <div v-if="hotList.length === 0 && !loadingHot" class="empty"
          >暂无最热UGC内容</div
        >
      </div>

      <!-- 最新UGC列表 -->
      <div class="content-item new-list" v-show="activeTab === 'new'">
        <div v-if="loadingNew" class="loading">加载中...</div>
        <div
          v-else
          class="ugc-item"
          v-for="(item, index) in newList"
          :key="index"
        >
          【最新】UGC内容{{ index + 1 }}：{{ item.content }}
        </div>
        <div v-if="newList.length === 0 && !loadingNew" class="empty"
          >暂无最新UGC内容</div
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopDetail',
  data() {
    return {
      // Tab相关：默认选中最热
      activeTab: 'hot',
      // Tab吸顶状态
      isTabFixed: false,
      // Tab栏原始顶部距离（门店详情的总高度）
      tabOffsetTop: 0,

      // UGC列表数据：缓存数据，切换不丢失
      hotList: [],
      newList: [],
      // 加载状态
      loadingHot: false,
      loadingNew: false,

      // 【核心！】缓存两个列表的滚动位置，切换Tab时保留
      hotScrollTop: 0,
      newScrollTop: 0,

      // 防抖定时器：优化滚动事件性能
      scrollTimer: null
    }
  },
  mounted() {
    // 1. DOM渲染完成后，获取Tab栏的原始顶部距离（必须$nextTick）
    this.$nextTick(() => {
      this.tabOffsetTop = this.$refs.tabRef.offsetTop
    })
    // 2. 监听页面滚动事件，处理吸顶逻辑
    window.addEventListener('scroll', this.handleScroll)
    // 3. 初始化加载【最热】UGC列表（默认选中）
    this.getHotUgcList()
  },
  beforeDestroy() {
    // 【必加】销毁页面时解绑滚动事件，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
    clearTimeout(this.scrollTimer)
  },
  methods: {
    // ========== 核心1：滚动事件处理 - Tab吸顶+滚动位置缓存 ==========
    handleScroll() {
      // 防抖优化：滚动事件高频触发，加防抖避免页面卡顿（50ms最优）
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        // 获取页面滚动距离（兼容所有浏览器）
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop

        // ✅ 逻辑1：判断是否吸顶
        this.isTabFixed = scrollTop >= this.tabOffsetTop

        // ✅ 逻辑2：缓存【当前激活Tab】的滚动位置
        if (this.activeTab === 'hot') {
          this.hotScrollTop = scrollTop
        } else {
          this.newScrollTop = scrollTop
        }
      }, 50)
    },

    // ========== 核心2：Tab切换逻辑 - 保留滚动位置+懒加载请求 ==========
    async changeTab(tabType) {
      // 1. 如果点击的是当前激活的Tab，不做任何操作
      if (this.activeTab === tabType) return

      // 2. 记录【切换前】的滚动位置（上面的handleScroll会自动缓存，无需额外处理）
      // 3. 切换Tab激活状态
      this.activeTab = tabType

      // 4. 按需请求数据：只有列表为空时，才发起接口请求，避免重复请求
      if (tabType === 'hot' && this.hotList.length === 0) {
        await this.getHotUgcList()
      } else if (tabType === 'new' && this.newList.length === 0) {
        await this.getNewUgcList()
      }

      // ✅ 核心！切回Tab后，精准回到上次的滚动位置（必须$nextTick，DOM渲染完成后赋值）
      this.$nextTick(() => {
        const targetScrollTop =
          tabType === 'hot' ? this.hotScrollTop : this.newScrollTop
        window.scrollTo(0, targetScrollTop)
      })
    },

    // ========== 最热UGC列表请求 ==========
    async getHotUgcList() {
      this.loadingHot = true
      try {
        // 替换成你的真实接口地址 + 参数
        // const res = await this.$http.get('你的接口地址', { type: 'hot' }, true);
        // this.hotList = res.data || [];

        // 模拟接口返回数据（测试用，删除替换真实接口）
        setTimeout(() => {
          this.hotList = Array(20).fill({
            content: '这是最热的UGC评论内容，滑动可以看更多'
          })
          this.loadingHot = false
        }, 500)
      } catch (err) {
        console.error('最热UGC请求失败', err)
        this.hotList = []
        this.loadingHot = false
      }
    },

    // ========== 最新UGC列表请求 ==========
    async getNewUgcList() {
      this.loadingNew = true
      try {
        // 替换成你的真实接口地址 + 参数
        // const res = await this.$http.get('你的接口地址', { type: 'new' }, true);
        // this.newList = res.data || [];

        // 模拟接口返回数据（测试用，删除替换真实接口）
        setTimeout(() => {
          this.newList = Array(20).fill({
            content: '这是最新的UGC评论内容，滑动可以看更多'
          })
          this.loadingNew = false
        }, 500)
      } catch (err) {
        console.error('最新UGC请求失败', err)
        this.newList = []
        this.loadingNew = false
      }
    }
  }
}
</script>

<style scoped>
/* 页面全局样式 */
.shop-detail-page {
  width: 100%;
  min-height: 100vh;
}
/* ========== 门店详情区：1.5个屏幕高度 ========== */
.shop-info-wrap {
  height: 150vh; /* 核心：1.5屏高度，按需调整 */
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shop-info {
  width: 90%;
  text-align: center;
}
.shop-info h2 {
  font-size: 20px;
  margin-bottom: 20px;
}
.shop-info p {
  font-size: 16px;
  line-height: 2;
  color: #333;
}
/* ========== Tab栏：核心样式 ========== */
/* Tab占位容器：解决吸顶页面跳动，高度和Tab一致 */
.tab-placeholder {
  width: 100%;
  overflow: hidden;
  transition: height 0.1s linear;
}
/* Tab基础样式 */
.tab-nav {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}
/* Tab吸顶样式：fixed固定在顶部 */
.tab-fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999; /* 置顶，防止被遮挡 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 加阴影，区分页面内容 */
}
/* Tab选项样式 */
.tab-item {
  flex: 1;
  height: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #666;
  cursor: pointer;
}
/* Tab激活样式 */
.tab-item.active {
  color: #e63946;
  font-weight: bold;
  border-bottom: 2px solid #e63946;
}
/* ========== UGC列表样式 ========== */
.tab-content {
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
}
.content-item {
  width: 100%;
}
.ugc-item {
  padding: 15px;
  border-bottom: 1px solid #eee;
  line-height: 1.6;
  color: #333;
}
.loading,
.empty {
  text-align: center;
  padding: 20px;
  color: #999;
}
</style>
